<ion-content class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-four title="Aviso de Compliance"></app-title-four>
  </div>

  <ion-grid class="form-data">
    <ion-row>
      <ion-col size="12">
        <section>
          <ion-label class="doc-content">
            Usted conoce y cumple plenamente con las leyes anticorrupción
            aplicables, tanto nacionales como extranjeras, como la Ley de
            Prácticas Corruptas en el Extranjero (US Foreign Corrupt Practices
            Act) y Códigos de Buenas Prácticas de la Industria Farmacéutica
            (ej.:IFPMA, CAEME, CIF). El solicitar esta prueba diagnóstica de
            ninguna manera influye, ni lo hará, en cualquier decisión o acción,
            en relación con cualquier negocio actual o futuro que tuviere con
            Sanofi. Tampoco implica ningún compromiso para prescribir, recetar o
            recomendar ningún producto de Sanofi. La prescripción de cualquier
            tratamiento quedará bajo su criterio profesional con base a la
            evaluación de su paciente. Usted no recibirá ningún beneficio de
            Sanofi en caso de prescribir algún producto de Sanofi, ni ningún
            detrimento en caso de no hacerlo.
          </ion-label>
        </section>
      </ion-col>
      <ion-col size="12" class="center">
        <button
          (click)="closeModal()"
          shape="round"
          class="btn-primary btn-close"
        >
          Cerrar
        </button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
